
    import { onMounted, ref, toRefs, computed, defineComponent, watch } from 'vue'
    import { useScroll } from '@vueuse/core'
    import { getMessage } from '@/store/messages'
    import useStore from '@/hooks/useStore'
    import useChat from '@/hooks/useChat'
    import useMessage from '@/hooks/useMessage'

    import MessageAudio from '@/components/Message/MessageAudio.vue'
    import MessageButton from '@/components/Message/MessageButton.vue'
    import MessageImage from '@/components/Message/MessageImage.vue'
    import MessageText from '@/components/Message/MessageText.vue'
    import MessageFile from '@/components/Message/MessageFile.vue'
    import MessageVideo from '@/components/Message/MessageVideo.vue'
    import PhotoUser from '@/components/Message/PhotoUser.vue'
    import MessageDivider from '@/components/Message/MessageDivider.vue'
    import Icon from '@/components/Icon/IndexIcon.vue'

    export default defineComponent({
        components: {
            MessageAudio,
            MessageButton,
            MessageFile,
            MessageImage,
            MessageText,
            MessageVideo,
            PhotoUser,
            MessageDivider,
            Icon
        },

        setup () {
            const { handleAddMessage } = useChat()
            const { StoreMessage } = useMessage()
            const containerMessage = ref<HTMLInputElement | null>(null)
            const { y, isScrolling, arrivedState } = useScroll(containerMessage)
            const { bottom } = toRefs(arrivedState)
            const positionMax = ref<number>(0)
            const toogleScroll = ref<boolean>(false)

            const chatmessages = computed(() => {
                return StoreMessage.map(item => {
                    const time = parseInt(item.timestamp.toString())
                    return {
                        id: item.id,
                        type: item.type,
                        content: {
                            id: item.id,
                            uuid: item.uuid,
                            position: item.type,
                            date: convertDate(time),
                            timestamp: item.timestamp,
                            ...item.content,
                            reply: {
                                ...item?.reply || null
                            }
                        },
                        component: getWebChatComponent(item.content.type)
                    }
                })
            })

            // TODO - Pegar os atendentes do banco de dados
            const attendance = computed(() => {
                return {
                    id: '123123',
                    photo: 'https://images.unsplash.com/photo-1499952127939-9bbf5af6c51c?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=facearea&w=256&h=256&facepad=2',
                    name: 'Maria Alice'
                }
            })

            watch(StoreMessage, () => setTimeout(() => scrollToEnd(), 10), { deep: true })

            watch(containerMessage, () => scrollToEnd())

            watch(isScrolling, () => {
                if (bottom.value) {
                    positionMax.value = y.value
                }

                if (positionMax.value - 200 > y.value) {
                    toogleScroll.value = true
                    return
                }

                toogleScroll.value = false
            })

            onMounted(() => scrollToEnd())

            function convertDate (date: number): string {
                if (date.toString().length === 10) date = date * 1000

                const d = new Date(date)
                const today = new Date()

                if (today.getDate() === d.getDate()) {
                    return `Hoje, às ${d.getHours()}h${d.getMinutes()}`
                } else if (today.getDate() === (d.getDate() + 1)) {
                    return `Ontem às ${d.getHours()}h${d.getMinutes()}`
                }

                return `${d.getDate()}/${d.getMonth()}/${d.getFullYear()}, às ${d.getHours()}h${d.getMinutes()}`
            }

            function handleClickInteract (id: string) {
                getMessage(id)
            }

            function handleClickMessage (action: string): void {
                handleAddMessage(action)
            }

            function getWebChatComponent (messageType: string): string {
                switch (messageType) {
                    case 'text':
                        return 'MessageText'
                    case 'image':
                        return 'MessageImage'
                    case 'audio':
                        return 'MessageAudio'
                    case 'video':
                        return 'MessageVideo'
                    case 'file':
                    case 'document':
                        return 'MessageFile'
                    case 'buttons':
                        return 'MessageButton'
                    case 'started':
                    case 'closed':
                    case 'system':
                        return 'MessageDivider'
                    default:
                        return 'none_' + messageType
                }
            }

            function scrollToEnd (): void {
                if (containerMessage.value) {
                    containerMessage.value.scrollTo({
                        top: containerMessage.value.scrollHeight,
                        behavior: 'smooth'
                    })
                }
            }

            const store = useStore()
            const bgColor = store.data.bgColor

            return {
                attendance,
                chatmessages,
                containerMessage,
                handleClickMessage,
                toogleScroll,
                scrollToEnd,
                y,
                isScrolling,
                arrivedState,
                handleClickInteract,
                bgColor
            }
        }
    })
